module.exports = __webpack_public_path__ + "static/media/linkedin.61a46958.svg";